import { ThemeConfig } from "antd";

export const MODAL_THEME: ThemeConfig = {
    token: {
        borderRadius: 2,
        colorBorder: "#ACBDCD",
        fontSize: 16,
        colorBgContainerDisabled: "rgba(0, 0, 0, 0.01)",
        colorTextDisabled: "rgba(0, 0, 0, 0.50)",
        controlHeight: 38
    },
    components: {
        Input: {
            inputFontSize: 16,
            paddingBlock: 6,
            colorTextPlaceholder: "var(--primary-hint)", 
        },
        Select: {
            fontSize: 16,
        },
        Form: {
            labelFontSize: 16,
            itemMarginBottom: 16,
            verticalLabelPadding: 3,
            labelColor: "var(--primary-label)",
        },
    }
}